<template>
  <div>
    <div class="flex flex-wrap">
        <div class="w-full xl:w-4/12 p-2" v-for="n in name.length" :key="n">
          <card-chart-name :name="name[--n]" :position="n" />
        </div>
    </div>
  </div>
</template>
<script>
/* 
  Class: CardCharts
  Description: This class representing a card with loaded chart names.
*/

/* Imports */
import Chart from "chart.js";
import ChartService from "@/services/chart.service.js";
import CardChartName from "./CardChartName.vue";
/* /Imports/ */

export default {
  /* 
    Define data with custom state values for specified chart. 
  */
  data() {
    return {
      isLoading: true,
      name: [],
      key: [],
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    CardChartName,
  },

  /* 
    Define props from which we got chart data_link, tag, response. 
  */
  props: {
    data_link: null,
    tag: null,
    response: null,
  },

  /* 
    Define watcher from which we got data_link for specified chart. 
  */
  watch: {
    data_link: {
      handler: function(newVal) {
        this.$loading(true);

        this.isLoading = false;
        ChartService.getChartData(newVal).then((response) => {
          this.response = response;
          this.getAllBuckets();
          this.$loading(false);
        });
        
        if (newVal) {
          this.name = [];
          this.key = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      We got all buckets (processes) for specified chart. 
    */
    getAllBuckets() {
      var buckets = this.response[this.tag].buckets;

      this.name = buckets.map((buck) => {
          return buck.key.toString();
      });

      this.key.push(this.response[this.tag]);
      localStorage.setItem("json_chart", JSON.stringify(this.key));
      this.createChart(this.name);
    },

    /* 
      Create line chart with different chart data (labels, links, processes). 
    */
    createChart(labels) {
      this.$nextTick(function() {
        var config = {
          type: "line",
          data: {
            labels: labels,
            datasets: [
              {
                label: new Date().getFullYear(),
                backgroundColor: "#4c51bf",
                borderColor: "#4c51bf",
                data: [65, 78, 66, 44, 56, 67, 75],
                fill: false,
              },
              {
                label: new Date().getFullYear() - 1,
                fill: false,
                backgroundColor: "#000",
                borderColor: "blue",
                data: [40, 68, 86, 74, 56, 60, 87],
              },
            ],
          },
          options: {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: false,
              text: "Sales Charts",
              fontColor: "black",
            },
            legend: {
              labels: {
                fontColor: "black",
              },
              align: "end",
              position: "bottom",
            },
            tooltips: {
              mode: "index",
              intersect: false,
            },
            hover: {
              mode: "nearest",
              intersect: true,
            },
            scales: {
              xAxes: [
                {
                  ticks: {
                    fontColor: "rgba(0,0,0,.7)",
                  },
                  display: true,
                  scaleLabel: {
                    display: false,
                    labelString: "Month",
                    fontColor: "white",
                  },
                  gridLines: {
                    display: false,
                    borderDash: [2],
                    borderDashOffset: [2],
                    color: "rgba(33, 37, 41, 0.3)",
                    zeroLineColor: "rgba(0, 0, 0, 0)",
                    zeroLineBorderDash: [2],
                    zeroLineBorderDashOffset: [2],
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: "rgba(0,0,0,.7)",
                  },
                  display: true,
                  scaleLabel: {
                    display: false,
                    labelString: "Value",
                    fontColor: "white",
                  },
                  gridLines: {
                    borderDash: [3],
                    borderDashOffset: [3],
                    drawBorder: false,
                    color: "rgba(0, 0, 0, 0.15)",
                    zeroLineColor: "rgba(33, 37, 41, 0)",
                    zeroLineBorderDash: [2],
                    zeroLineBorderDashOffset: [2],
                  },
                },
              ],
            },
          },
        };

        var ctx = document.getElementById("line-chart").getContext("2d");
        window.myLine = new Chart(ctx, config);
      });
    },
  },
};
</script>
